import {FunctionalComponent, h} from "preact";
import {useEffect} from "preact/hooks";

const ClearChat: FunctionalComponent<{
    msgID: string;
    clearChatCallback: () => void;
    tickCallback: () => void;
}> = ({
          msgID,
          clearChatCallback,
          tickCallback
      }) => {

    useEffect(() => {
        // log.info(`typing for msgID ${msgID}`);
        /** advance queue */
        clearChatCallback();
        tickCallback();
    }, [msgID]);

    return null;
}

export default ClearChat;
